import { Badge, BodyText, Flex } from '@utilitywarehouse/hearth-react';
import { FC } from 'react';

import { formatCurrency } from '@utils/format';
import { convertValueToCurrency } from '@utils/price';

interface CashbackSavingsItemProps {
  cashbackValue: Nullable<string>;
}

const CashbackSavingsItem: FC<CashbackSavingsItemProps> = ({
  cashbackValue,
}) => {
  if (!cashbackValue) {
    return null;
  }

  return (
    <Flex
      spacing="xs"
      direction="column"
      alignItems="end"
      data-testid="basket-item-cashback-savings"
    >
      <BodyText size="sm" textAlign="right" color="secondary">
        Estimated cashback earnings
      </BodyText>
      <Badge variant="subtle" colorScheme="positive" size="sm">
        -{formatCurrency(convertValueToCurrency(Number(cashbackValue)))}
      </Badge>
    </Flex>
  );
};

export { CashbackSavingsItem };
